import { render, staticRenderFns } from "./CardBuilds.vue?vue&type=template&id=3c1a9b50&scoped=true"
import script from "./CardBuilds.vue?vue&type=script&lang=js"
export * from "./CardBuilds.vue?vue&type=script&lang=js"
import style0 from "./CardBuilds.vue?vue&type=style&index=0&id=3c1a9b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a9b50",
  null
  
)

export default component.exports